import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-heat",
  "use": "icon-heat-usage",
  "viewBox": "0 0 1068 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1068 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-heat\"><path d=\"M518.099478 0l518.099479 376.431304-197.899131 609.057392H197.89913L0 376.431304 518.099478 0z m0 110.057739L104.670609 410.490435l157.918608 485.999304h511.020522L931.528348 410.490435l-413.42887-300.388174z m0 137.572174l338.765913 187.080348-129.424695 398.202435-406.483479-21.014261-141.57913-377.188174 338.721391-187.080348z\" p-id=\"5560\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol